import React from "react";
import { Box, Typography, Button, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";

const HeroBanner = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        position: "relative",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        backgroundImage:
          "url(https://images.unsplash.com/photo-1643237202321-8f8de00975ad?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Dark Overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background: "rgba(0,0,0,0.45)",
        }}
      />

      <Container maxWidth="md" sx={{ position: "relative", zIndex: 1 }}>
        <Typography
          variant="overline"
          sx={{
            color: "#A67C00",
            letterSpacing: 3,
            fontWeight: 600,
          }}
        >
          Premium  Collection Here
        </Typography>

        <Typography
          variant="h2"
          sx={{
            fontWeight: 700,
            color: "#fff",
            mt: 2,
            mb: 3,
            fontSize: { xs: "2rem", md: "3.5rem" },
          }}
        >
          Jewellery as Unique as You
        </Typography>

        <Typography
          variant="h6"
          sx={{
            color: "#f5f5f5",
            mb: 4,
            fontWeight: 400,
          }}
        >
          Discover timeless designs crafted to celebrate your elegance.
        </Typography>

        <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate("/filter/All")}
            sx={{
              bgcolor: "#d4af37",
              color: "#000",
              px: 4,
              py: 1.5,
              fontWeight: 600,
              "&:hover": { bgcolor: "#b8962e" },
            }}
          >
            Shop Now
          </Button>

          <Button
            variant="outlined"
            size="large"
            onClick={() => navigate("/")}
            sx={{
              borderColor: "#fff",
              color: "#fff",
              px: 4,
              py: 1.5,
              fontWeight: 600,
              "&:hover": {
                borderColor: "#d4af37",
                color: "#d4af37",
              },
            }}
          >
            Explore
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default HeroBanner;
